import React, { useState } from "react";

import { useVentasCanceladas } from "../../../hooks/useVentasCanceladas.js";

// Componentes
import TituloModulo from "../../../componentsUI/estructura/tituloModulos/tituloModulo.js";
import VentaCard from "../tarjetaVentas/ventaCard.js";
import "./facturasLista.css";

export default function ListaFacturasCanceladas() {
  // Extraemos solo las ventas canceladas usando custome hook 
  const { ventas, loading } = useVentasCanceladas();
  // Estado para controlar qué factura está abierta
  const [facturaAbierta, setFacturaAbierta] = useState(null);
  // mensaje de carga
  if (loading) return <div>Cargando...</div>;

  return (
    <div>
      <TituloModulo titulo="Facturas Canceladas" />

      <div className="contenedor-lista">
        {ventas.map((factura) => (
          <VentaCard
            key={factura.id_factura || factura.numero_factura} 
            factura={factura} 
            abierta={facturaAbierta === factura.numero_factura}
            onToggle={() =>
              setFacturaAbierta(
                facturaAbierta === factura.numero_factura
                  ? null
                  : factura.numero_factura
              )
            }
          />
        ))}
      </div>
    </div>
  );
}
